module.exports = __webpack_public_path__ + "img/pretty-boat.a0c3209c.jpg";